/* Bain Blends — Living Street hero background (sections/bb-living-street.liquid) */
(function(){
  if (window.BBLivingStreet) return;

  function initStreet(root){

  const cvs = root.querySelector('.bbls__canvas');
  if (!cvs || !cvs.getContext) return null;
  const ctx = cvs.getContext('2d');
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const on = k => root.dataset[k] !== 'false';
  const opt = { embers:on('embers'), windows:on('windows'), lamps:on('lamps'), fog:on('fog'),
    smoke:on('smoke'), clock:on('clock'), motion:!reduceMotion,
    season: root.dataset.season || 'none' };
  const skyTop = root.dataset.skyTop || '#120803', skyHorizon = root.dataset.skyHorizon || '#4a2210';
  function mix(a,b,k){ const p=h=>[1,3,5].map(i=>parseInt(h.slice(i,i+2),16)); const A=p(a),B=p(b);
    return 'rgb('+A.map((v,i)=>Math.round(v+(B[i]-v)*k)).join(',')+')'; }

  let W=0, H=0, DPR=1, S=1, ground=0;
  let farLayer, nearLayer, frontLayer, skyGrad;
  let farWins=[], nearWins=[], lamps=[], fog=[], embers=[], flakes=[], smokes=[], smokeSrc=[], tower=null;
  let rand = Math.random;

  // ---------- helpers ----------
  function seeded(seed){ return () => { seed|=0; seed=seed+0x6D2B79F5|0; let t=Math.imul(seed^seed>>>15,1|seed);
    t=t+Math.imul(t^t>>>7,61|t)^t; return ((t^t>>>14)>>>0)/4294967296; }; }
  function layer(){ const c=document.createElement('canvas'); c.width=W*DPR; c.height=H*DPR;
    const x=c.getContext('2d'); x.setTransform(DPR,0,0,DPR,0,0); return {c, x}; }
  function sprite(r,g,b,size=128){ // soft radial glow, drawn once and reused
    const c=document.createElement('canvas'); c.width=c.height=size; const x=c.getContext('2d');
    const gr=x.createRadialGradient(size/2,size/2,0,size/2,size/2,size/2);
    gr.addColorStop(0,`rgba(${r},${g},${b},1)`); gr.addColorStop(.25,`rgba(${r},${g},${b},.45)`);
    gr.addColorStop(.6,`rgba(${r},${g},${b},.1)`); gr.addColorStop(1,`rgba(${r},${g},${b},0)`);
    x.fillStyle=gr; x.fillRect(0,0,size,size); return c; }
  const SPR = {
    window: sprite(255,150,70), lamp: sprite(255,190,110), ember: sprite(255,120,40,64),
    fog: sprite(150,82,42), smoke: sprite(80,55,52), moon: sprite(230,205,170)
  };
  function glow(img,x,y,rx,ry,a){ if(a<=0) return; ctx.globalAlpha=a; ctx.drawImage(img,x-rx,y-ry,rx*2,ry*2); }

  // ---------- build the town (re-run on resize, seeded so it stays the same) ----------
  function build(){
    const R = seeded(1897);
    const compact = root.dataset.compact === 'true';
    S = Math.max(compact ? .38 : .6, Math.min(1.35, Math.min(W/1400, H/900) * 1.15));
    ground = H*0.93;
    farWins=[]; nearWins=[]; smokeSrc=[]; lamps=[];
    farLayer=layer(); nearLayer=layer(); frontLayer=layer();

    skyGrad = ctx.createLinearGradient(0,0,0,H);
    skyGrad.addColorStop(0,skyTop); skyGrad.addColorStop(.45,mix(skyTop,skyHorizon,.18));
    skyGrad.addColorStop(.8,mix(skyTop,skyHorizon,.75)); skyGrad.addColorStop(1,skyHorizon);

    row(farLayer.x, R, {base:ground-H*.03, minH:H*.13, maxH:H*.28, minW:38*S, maxW:105*S,
      color:'#1c0d05', pane:'#251207', win:3*S, lit:.22, list:farWins, near:false});
    row(nearLayer.x, R, {base:ground, minH:H*.1, maxH:H*.25, minW:75*S, maxW:175*S,
      color:'#0b0502', pane:'#180b04', win:5.2*S, lit:.32, list:nearWins, near:true});
    buildTower(nearLayer.x, R);
    buildStreet(frontLayer.x, R);

    fog = Array.from({length:7}, (_,i)=>({ x:R()*W, y:ground - R()*H*.32, rx:(260+R()*380)*S, ry:(60+R()*70)*S,
      vx:(4+R()*10)*(R()<.5?-1:1), a:.05+R()*.06, front:i>4 }));
    const n = Math.round(Math.min(90, W*H/22000));
    embers = Array.from({length:n}, ()=>newEmber(true));
    smokes = [];
    const nf = opt.season==='leaves' ? Math.round(Math.max(8, Math.min(22, W/65)))
             : opt.season==='snow' ? Math.round(Math.min(140, W*H/9000)) : 0;
    flakes = Array.from({length:nf}, ()=>newFlake(true));
  }

  function row(c, R, o){
    let x = -15;
    while (x < W+15){
      const w = o.minW + R()*(o.maxW-o.minW);
      const cx = (x+w/2)/W, edge = Math.min(1, Math.abs(cx-.5)*2.3);
      const shape = o.near ? .72 + .28*edge : .82 + .18*edge;          // lower in the middle so the copy breathes
      const h = (o.minH + R()*(o.maxH-o.minH)) * shape;
      const top = o.base - h;
      c.fillStyle = o.color;
      c.fillRect(x, top, w, H);

      // roofline
      const kind = R(); let roofAt = () => top;
      if (kind < .28){                                   // gable
        const rh = w*(.22+R()*.22);
        c.beginPath(); c.moveTo(x-2,top); c.lineTo(x+w/2,top-rh); c.lineTo(x+w+2,top); c.fill();
        roofAt = xx => top - rh*(1-Math.abs((xx-(x+w/2))/(w/2)));
      } else if (kind < .52){                            // mansard with dormers
        const rh = w*.17;
        c.beginPath(); c.moveTo(x-3,top); c.lineTo(x+w*.12,top-rh); c.lineTo(x+w*.88,top-rh); c.lineTo(x+w+3,top); c.fill();
        roofAt = () => top - rh;
        const dn = Math.max(1, Math.floor(w/(40*S)));
        for (let i=0;i<dn;i++){
          const dx = x + w*(.2 + .6*(dn===1?.5:i/(dn-1))) - o.win*1.2, dw=o.win*2.4, dh=o.win*3;
          c.beginPath(); c.moveTo(dx-o.win*.4, top-rh*.25); c.lineTo(dx-o.win*.4, top-rh*.25-dh);
          c.lineTo(dx+dw/2, top-rh*.25-dh-o.win*1.4); c.lineTo(dx+dw+o.win*.4, top-rh*.25-dh); c.lineTo(dx+dw+o.win*.4, top-rh*.25); c.fill();
          addWin(c, o, dx+o.win*.3, top-rh*.25-dh+o.win*.6, dw-o.win*.6, dh-o.win*1.1, R, 'candle');
        }
      } else if (kind < .64 && w > 70*S){                // corner turret
        const tw = w*.3, tx = R()<.5 ? x : x+w-tw, th = h*.13;
        c.fillRect(tx, top-th, tw, th+1);
        c.beginPath(); c.moveTo(tx-3,top-th); c.lineTo(tx+tw/2, top-th-tw*1.5); c.lineTo(tx+tw+3, top-th); c.fill();
        c.fillRect(tx+tw/2-.8*S, top-th-tw*1.5-8*S, 1.6*S, 8*S);
        addWin(c, o, tx+tw/2-o.win*.8, top-th+o.win*.7, o.win*1.6, Math.max(o.win*1.6, th-o.win*1.6), R, 'candle');
      } else {                                           // flat with cornice + parapet
        c.fillRect(x-3*S, top-3*S, w+6*S, 3*S);
        if (R()<.5){ c.fillRect(x+w*.3, top-7*S, w*.4, 7*S); }
      }

      // chimneys
      const nc = Math.floor(R()*3);
      for (let i=0;i<nc;i++){
        const cw=(5+R()*5)*S*(o.near?1.2:.8), chx = x + 4 + R()*(w-cw-8), chh=(9+R()*20)*S*(o.near?1:.7);
        const base = roofAt(chx+cw/2);
        c.fillRect(chx, base-chh, cw, chh+(top-base)+2);
        c.fillRect(chx-1.5*S, base-chh-2*S, cw+3*S, 2.5*S);
        if (o.near && R()<.35) smokeSrc.push({x:chx+cw/2, y:base-chh-2*S, t:R()*2});
      }

      // window grid
      const ws=o.win, ww=ws*1.7, wh=ws*2.8;
      const cols = Math.max(1, Math.floor((w-ws*2)/(ww+ws*1.6)));
      const rows = Math.max(1, Math.floor((h-ws*5)/(wh+ws*2.4)));
      const gx = (w-cols*ww)/(cols+1);
      for (let r=0;r<rows;r++) for (let col=0; col<cols; col++){
        const wy = top + ws*2.6 + r*(wh+ws*2.4);
        if (wy+wh > o.base - (o.near ? ws*6 : ws*2)) continue;
        addWin(c, o, x+gx+col*(ww+gx), wy, ww, wh, R);
      }
      // ground-floor shopfront on near buildings
      if (o.near && w > 95*S && R()<.55){
        const sw=w*.62, sh=ws*4.2, sx=x+(w-sw)/2, sy=o.base-sh-ws*1.2;
        c.fillStyle=o.color; c.fillRect(sx-ws*.6, sy-ws*1.2, sw+ws*1.2, ws*.8); // sign board
        addWin(c, o, sx, sy, sw, sh, R, 'shop');
      }
      x += w + (R()<.25 ? R()*10*S : -1);
    }
  }

  function addWin(c, o, x, y, w, h, R, kind){
    c.fillStyle = o.pane; c.fillRect(x, y, w, h);
    kind = kind || (R()<.55 ? 'candle' : 'gas');
    const lit = kind==='shop' ? R()<.8 : R()<o.lit;
    o.list.push({ x, y, w, h, kind, near:o.near, b: lit?1:0, target: lit?1:0, p:R()*100,
      next: 4 + R()*30, frame:o.color, mull: Math.max(1, o.win*.28) });
  }

  function buildTower(c, R){
    const narrow = W < 760;
    const tw = 54*S, tx = W*(narrow ? .82 : .8) - tw/2, th = H*(narrow ? .24 : .36), top = ground - th;
    c.fillStyle = '#0b0502';
    c.fillRect(tx, top, tw, th+10);
    c.fillRect(tx-4*S, top-4*S, tw+8*S, 4*S);
    // belfry stage + spire
    const bw = tw*.78, bx = tx+(tw-bw)/2, bh = tw*.9;
    c.fillRect(bx, top-bh, bw, bh);
    c.fillRect(bx-3*S, top-bh-3*S, bw+6*S, 3*S);
    c.beginPath(); c.moveTo(bx-3*S, top-bh-3*S); c.lineTo(tx+tw/2, top-bh-tw*2.1); c.lineTo(bx+bw+3*S, top-bh-3*S); c.fill();
    c.fillRect(tx+tw/2-1*S, top-bh-tw*2.1-14*S, 2*S, 14*S);
    tower = { cx: tx+tw/2, cy: top+tw*.62, r: tw*.34 };
    // belfry arches as windows
    const o = {pane:'#180b04', list:nearWins, near:true, color:'#0b0502', win:5.2*S};
    addWin(c, o, bx+bw*.18, top-bh+bh*.25, bw*.22, bh*.55, R, 'gas');
    addWin(c, o, bx+bw*.6,  top-bh+bh*.25, bw*.22, bh*.55, R, 'gas');
    for (let i=0;i<3;i++) addWin(c, o, tx+tw/2-4*S, top+tw*1.3+i*th*.18, 8*S, 16*S, R, 'candle');
  }

  function buildStreet(c, R){
    const g = c.createLinearGradient(0, ground, 0, H);
    g.addColorStop(0,'#0b0404'); g.addColorStop(1,'#080401');
    c.fillStyle = g; c.fillRect(0, ground, W, H-ground);
    c.fillStyle='#1e0e06'; c.fillRect(0, ground, W, 1.5*S);            // curb line
    c.strokeStyle='rgba(90,40,30,.12)'; c.lineWidth=1;                 // faint cobbles
    for (let y=ground+5*S; y<H; y+=5*S){
      c.beginPath(); c.moveTo(0,y); c.lineTo(W,y); c.stroke();
      const off = (y/5)%2 ? 0 : 7*S;
      for (let x=off; x<W; x+=14*S){ c.beginPath(); c.moveTo(x,y-5*S); c.lineTo(x,y); c.stroke(); }
    }
    const xs = W < 760 ? [.08,.92] : [.05,.25,.75,.95];
    xs.forEach(f => {
      const x = W*f, ph = 175*S, top = ground - ph;
      c.fillStyle = '#080401';
      c.fillRect(x-3*S, top, 6*S, ph);                                 // post
      c.beginPath(); c.moveTo(x-10*S, ground); c.lineTo(x-5*S, ground-26*S); c.lineTo(x+5*S, ground-26*S); c.lineTo(x+10*S, ground); c.fill(); // base
      c.fillRect(x-7*S, ground-60*S, 14*S, 3*S);                       // collar
      c.fillRect(x-14*S, top+6*S, 28*S, 2*S);                          // ladder bar
      lamps.push({ x, y: top - 14*S, p:R()*100, nextSput: 6 + R()*20, sputEnd:0 });
    });
  }

  // ---------- particles ----------
  function newEmber(anyY){
    return { x: rand()*W, y: anyY ? rand()*H : H + 10, vy: (8+rand()*22)*S, r:(1+rand()*2.2)*S,
      sway: 6+rand()*18, ph: rand()*6.28, tw: 1+rand()*3 };
  }

  const LEAF_COLS = ['#b8321a','#d0561c','#e0862a','#a8240f','#c9701f','#8f3a12','#d99a34'];
  function newFlake(anyY){
    const leaf = opt.season==='leaves';
    return { x: rand()*W, y: anyY ? rand()*H : -30, vy: leaf ? (24+rand()*26)*S : (14+rand()*24)*S,
      size: leaf ? (11+rand()*11)*S : (.8+rand()*2)*S, rot: rand()*6.28, vr: (rand()-.5)*1.8,
      sway: leaf ? 30+rand()*55 : 6+rand()*18, ph: rand()*6.28, fl: rand()*6.28,
      col: LEAF_COLS[Math.floor(rand()*LEAF_COLS.length)], depth: .55+rand()*.45 };
  }
  const LEAF = [[0,-1],[.18,-.55],[.45,-.72],[.38,-.35],[.85,-.42],[.62,-.1],[.78,.05],[.4,.12],[.45,.35],[.12,.22],[0,.45],
    [-.12,.22],[-.45,.35],[-.4,.12],[-.78,.05],[-.62,-.1],[-.85,-.42],[-.38,-.35],[-.45,-.72],[-.18,-.55]];
  function drawSeason(t, dt){
    if (!flakes.length) return;
    const leaf = opt.season==='leaves';
    for (let i=0;i<flakes.length;i++){
      const f = flakes[i];
      if (opt.motion){ f.y += f.vy*dt*f.depth; f.rot += f.vr*dt; if (f.y > H+30) flakes[i] = newFlake(false); }
      const x = f.x + Math.sin(t*.7 + f.ph)*f.sway;
      if (leaf){
        ctx.save(); ctx.translate(x, f.y); ctx.rotate(f.rot);
        ctx.scale(1, .5 + .5*Math.abs(Math.sin(t*1.2 + f.fl)));            // tumbling
        ctx.globalAlpha = .9*f.depth; ctx.fillStyle = f.col; ctx.beginPath();
        LEAF.forEach(([a,b],k) => k ? ctx.lineTo(a*f.size,b*f.size) : ctx.moveTo(a*f.size,b*f.size));
        ctx.closePath(); ctx.fill();
        ctx.strokeStyle='rgba(70,25,6,.7)'; ctx.lineWidth=Math.max(.7,f.size*.07);
        ctx.beginPath(); ctx.moveTo(0,-f.size*.6); ctx.lineTo(0,f.size*.8); ctx.stroke();
        ctx.restore();
      } else {
        ctx.globalAlpha = .75*f.depth; ctx.fillStyle = '#f4ece2';
        ctx.beginPath(); ctx.arc(x, f.y, f.size, 0, 6.283); ctx.fill();
      }
    }
    ctx.globalAlpha = 1;
  }

  // ---------- draw ----------
  function flick(w, t){
    if (!opt.motion) return 1;
    if (w.kind === 'candle') return .8 + .09*Math.sin(t*8.3+w.p) + .06*Math.sin(t*14.9+w.p*1.7) + .04*Math.sin(t*23.1+w.p*.3);
    if (w.kind === 'shop')   return .92 + .04*Math.sin(t*2.7+w.p);
    return .95 + .03*Math.sin(t*1.9+w.p);
  }

  function drawWindows(list, t, dt){
    const near = list[0] && list[0].near;
    for (const w of list){
      if (opt.motion){
        if (t > w.next){                                   // people going to bed / coming home
          w.next = t + 6 + rand()*40;
          if (rand() < .5) w.target = w.target ? 0 : 1;
        }
        w.b += (w.target - w.b) * Math.min(1, dt*(w.target ? .9 : .5));
      }
      const a = w.b * flick(w, t);
      if (a < .02) continue;
      const warm = w.kind==='candle' ? '255,150,62' : w.kind==='shop' ? '255,178,96' : '255,205,130';
      ctx.globalCompositeOperation='source-over';
      ctx.globalAlpha = a * (w.kind==='shop' ? .62 : near ? .92 : .55);
      ctx.fillStyle = `rgb(${warm})`; ctx.fillRect(w.x, w.y, w.w, w.h);
      // inner warmth gradient toward the bottom (candle sits on sill)
      ctx.globalAlpha = a * .35; ctx.fillStyle = 'rgb(255,230,170)';
      ctx.fillRect(w.x+w.w*.25, w.y+w.h*.45, w.w*.5, w.h*.45);
      // mullions
      ctx.globalAlpha = 1; ctx.fillStyle = w.frame;
      if (w.kind==='shop'){
        for (let i=1;i<4;i++) ctx.fillRect(w.x+w.w*i/4 - w.mull/2, w.y, w.mull, w.h);
        ctx.fillRect(w.x, w.y+w.h*.28, w.w, w.mull);
      } else {
        ctx.fillRect(w.x+w.w/2-w.mull/2, w.y, w.mull, w.h);
        ctx.fillRect(w.x, w.y+w.h*.42, w.w, w.mull);
      }
      // glow spill
      ctx.globalCompositeOperation='lighter';
      const s = Math.max(w.w, w.h) * (w.kind==='shop' ? 1.1 : 1.8);
      glow(SPR.window, w.x+w.w/2, w.y+w.h/2, s, s, a * (near ? .22 : .12));
    }
    ctx.globalCompositeOperation='source-over'; ctx.globalAlpha=1;
  }

  function drawClock(){
    const {cx, cy, r} = tower, d = new Date();
    ctx.globalCompositeOperation='lighter';
    glow(SPR.lamp, cx, cy, r*3.2, r*3.2, .35);
    ctx.globalCompositeOperation='source-over';
    ctx.globalAlpha=1; ctx.fillStyle='#e8c98a'; ctx.beginPath(); ctx.arc(cx,cy,r,0,6.283); ctx.fill();
    ctx.strokeStyle='#0b0502'; ctx.lineWidth=Math.max(1.5, r*.12); ctx.stroke();
    ctx.fillStyle='#3a1a10';
    for (let i=0;i<12;i++){ const an=i*Math.PI/6; ctx.fillRect(cx+Math.cos(an)*r*.78-1, cy+Math.sin(an)*r*.78-1, 2, 2); }
    const hr = (d.getHours()%12 + d.getMinutes()/60) * Math.PI/6 - Math.PI/2;
    const mn = (d.getMinutes() + d.getSeconds()/60) * Math.PI/30 - Math.PI/2;
    ctx.strokeStyle='#1a0a06'; ctx.lineCap='round';
    ctx.lineWidth=Math.max(1.5,r*.12); ctx.beginPath(); ctx.moveTo(cx,cy); ctx.lineTo(cx+Math.cos(hr)*r*.5, cy+Math.sin(hr)*r*.5); ctx.stroke();
    ctx.lineWidth=Math.max(1,r*.07);  ctx.beginPath(); ctx.moveTo(cx,cy); ctx.lineTo(cx+Math.cos(mn)*r*.78, cy+Math.sin(mn)*r*.78); ctx.stroke();
  }

  function drawFog(front, dt){
    ctx.globalCompositeOperation='lighter';
    for (const f of fog){
      if (f.front !== front) continue;
      if (opt.motion){ f.x += f.vx*dt; if (f.x - f.rx > W) f.x = -f.rx; if (f.x + f.rx < 0) f.x = W + f.rx; }
      glow(SPR.fog, f.x, f.y, f.rx, f.ry, f.a * (front ? .7 : 1));
    }
    ctx.globalCompositeOperation='source-over'; ctx.globalAlpha=1;
  }

  function drawLamps(t){
    for (const l of lamps){
      let b = 1;
      if (opt.motion){
        b = .93 + .04*Math.sin(t*4.1+l.p) + .03*Math.sin(t*11.3+l.p*2);
        if (t > l.nextSput){ l.sputEnd = t + .4 + rand()*1.1; l.nextSput = t + 10 + rand()*35; }
        if (t < l.sputEnd) b *= .45 + .35*Math.abs(Math.sin(t*9));   // gas sputter, kept under 3 flashes/sec
      }
      const x=l.x, y=l.y;
      // big atmospheric halo + tight core
      ctx.globalCompositeOperation='lighter';
      glow(SPR.lamp, x, y, 330*S*b, 330*S*b, .16*b);
      glow(SPR.lamp, x, y, 95*S, 95*S, .55*b);
      // reflection on wet cobbles
      glow(SPR.lamp, x, ground + (H-ground)*.5, 26*S, (H-ground)*.9, .35*b);
      ctx.globalCompositeOperation='source-over';
      // glass
      ctx.globalAlpha = .55 + .45*b; ctx.fillStyle='rgb(255,214,140)';
      ctx.beginPath(); ctx.moveTo(x-9*S,y-10*S); ctx.lineTo(x+9*S,y-10*S); ctx.lineTo(x+5.5*S,y+12*S); ctx.lineTo(x-5.5*S,y+12*S); ctx.fill();
      ctx.globalAlpha = .9*b; ctx.fillStyle='rgb(255,248,220)';
      ctx.beginPath(); ctx.arc(x, y+3*S, 3*S, 0, 6.283); ctx.fill();          // mantle
      // iron frame
      ctx.globalAlpha=1; ctx.fillStyle='#080401';
      ctx.fillRect(x-.8*S, y-10*S, 1.6*S, 22*S);
      ctx.fillRect(x-7*S, y+12*S, 14*S, 3*S);
      ctx.beginPath(); ctx.moveTo(x-13*S,y-10*S); ctx.lineTo(x,y-21*S); ctx.lineTo(x+13*S,y-10*S); ctx.fill();
      ctx.fillRect(x-1.2*S, y-27*S, 2.4*S, 7*S);
      ctx.beginPath(); ctx.arc(x, y-28*S, 2.2*S, 0, 6.283); ctx.fill();
    }
  }

  function drawSmoke(t, dt){
    if (opt.motion){
      for (const s of smokeSrc){ s.t -= dt; if (s.t <= 0){ s.t = .5 + rand()*.6;
        smokes.push({ x:s.x, y:s.y, r:6*S, a:.0, life:0, max:7+rand()*4, vx:(5+rand()*5)*S, vy:(10+rand()*6)*S }); } }
    }
    ctx.globalCompositeOperation='lighter';
    for (let i=smokes.length-1;i>=0;i--){
      const p = smokes[i];
      if (opt.motion){ p.life += dt; p.x += p.vx*dt; p.y -= p.vy*dt; p.r += 6*S*dt; }
      const k = p.life/p.max; if (k>=1){ smokes.splice(i,1); continue; }
      glow(SPR.smoke, p.x, p.y, p.r, p.r, .22*Math.sin(k*Math.PI));
    }
    ctx.globalCompositeOperation='source-over'; ctx.globalAlpha=1;
  }

  function drawEmbers(t, dt){
    ctx.globalCompositeOperation='lighter';
    for (let i=0;i<embers.length;i++){
      const e = embers[i];
      if (opt.motion){ e.y -= e.vy*dt; if (e.y < -20) embers[i] = newEmber(false); }
      const x = e.x + Math.sin(t*.6 + e.ph)*e.sway;
      const fade = Math.min(1, e.y/(H*.35)) * Math.min(1,(H - e.y)/60 + .2);
      const a = Math.max(0, fade) * (.55 + .45*Math.sin(t*e.tw + e.ph));
      glow(SPR.ember, x, e.y, e.r*5, e.r*5, a*.7);
      ctx.globalAlpha = a; ctx.fillStyle='rgb(255,190,120)';
      ctx.beginPath(); ctx.arc(x, e.y, e.r*.55, 0, 6.283); ctx.fill();
    }
    ctx.globalCompositeOperation='source-over'; ctx.globalAlpha=1;
  }

  let last = performance.now(), t0 = last, raf = 0, running = true;
  function frame(now){
    const dt = Math.min(.05, (now-last)/1000); last = now; const t = (now-t0)/1000;
    ctx.globalAlpha=1; ctx.globalCompositeOperation='source-over';
    ctx.fillStyle = skyGrad; ctx.fillRect(0,0,W,H);
    // hazy moon
    ctx.globalCompositeOperation='lighter';
    glow(SPR.moon, W*.13, H*.16, 160*S, 160*S, .12);
    glow(SPR.moon, W*.13, H*.16, 26*S, 26*S, .5);
    ctx.globalCompositeOperation='source-over';

    if (opt.smoke) drawSmoke(t, dt);
    ctx.globalAlpha=1; ctx.drawImage(farLayer.c, 0, 0, W, H);
    if (opt.windows) drawWindows(farWins, t, dt);
    if (opt.fog) drawFog(false, dt);
    ctx.globalAlpha=1; ctx.drawImage(nearLayer.c, 0, 0, W, H);
    if (opt.windows) drawWindows(nearWins, t, dt);
    if (opt.clock) drawClock();
    ctx.globalAlpha=1; ctx.drawImage(frontLayer.c, 0, 0, W, H);
    if (opt.lamps) drawLamps(t);
    if (opt.fog) drawFog(true, dt);
    if (opt.embers) drawEmbers(t, dt);
    drawSeason(t, dt);

    if (running) raf = requestAnimationFrame(frame);
  }

  function resize(){
    DPR = Math.min(window.devicePixelRatio || 1, 2);
    const r = cvs.getBoundingClientRect(); W = r.width; H = r.height;
    cvs.width = Math.round(W*DPR); cvs.height = Math.round(H*DPR);
    ctx.setTransform(DPR,0,0,DPR,0,0);
    build();
    if (!running) frame(performance.now());
  }

  function start(){ if (running) return; running = true; last = performance.now(); raf = requestAnimationFrame(frame); }
  function stop(){ running = false; cancelAnimationFrame(raf); }

  // pause when the tab is hidden or the hero scrolls out of view (saves battery)
  let visible = true;
  const onVis = () => (document.hidden || !visible) ? stop() : start();
  document.addEventListener('visibilitychange', onVis);
  let io = null;
  if ('IntersectionObserver' in window){
    io = new IntersectionObserver(([e]) => { visible = e.isIntersecting; onVis(); });
    io.observe(root);
  }
  let rt, lastW = 0;
  const ro = new ResizeObserver(() => {
    clearTimeout(rt);
    rt = setTimeout(() => {
      const r = cvs.getBoundingClientRect();
      // ignore height-only jitter from mobile browser toolbars
      if (Math.abs(r.width - lastW) < 1 && Math.abs(r.height - H) < 80) return;
      lastW = r.width; resize();
    }, 120);
  });
  ro.observe(root);

  resize(); lastW = W;
  raf = requestAnimationFrame(frame);

  return function destroy(){
    stop(); ro.disconnect(); if (io) io.disconnect();
    document.removeEventListener('visibilitychange', onVis);
  };
  }

  const instances = new WeakMap();
  function mount(root){ if (instances.has(root)) return; const d = initStreet(root); if (d) instances.set(root, d); }
  function unmount(root){ const d = instances.get(root); if (d){ d(); instances.delete(root); } }
  function mountAll(scope){ (scope || document).querySelectorAll('[data-bbls]').forEach(mount); }

  window.BBLivingStreet = { mount, unmount, mountAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mountAll());
  else mountAll();

  // Shopify theme editor: re-run when the section is added or its settings change
  document.addEventListener('shopify:section:load', e => mountAll(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-bbls]').forEach(unmount));
})();
